import { useNavigate } from 'react-router-dom'
import type { World, WorldStatus } from '@/types'
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '@/components/ui/card'
import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'

interface WorldCardProps {
  world: World
  nationCount?: number
}

const statusConfig: Record<WorldStatus, { label: string; className: string }> = {
  setup: {
    label: 'Setup',
    className: 'bg-gray-100 text-gray-800 border-gray-200',
  },
  active: {
    label: 'Active',
    className: 'bg-green-100 text-green-800 border-green-200',
  },
  paused: {
    label: 'Paused',
    className: 'bg-yellow-100 text-yellow-800 border-yellow-200',
  },
  completed: {
    label: 'Completed',
    className: 'bg-blue-100 text-blue-800 border-blue-200',
  },
}

export function WorldCard({ world, nationCount }: WorldCardProps) {
  const navigate = useNavigate()
  const status = statusConfig[world.status]

  return (
    <Card
      className="cursor-pointer transition-shadow hover:shadow-md"
      onClick={() => navigate(`/worlds/${world.id}`)}
    >
      <CardHeader>
        <div className="flex items-start justify-between">
          <CardTitle>{world.name}</CardTitle>
          <Badge className={cn('ml-2', status.className)}>{status.label}</Badge>
        </div>
        <CardDescription>Click to view world details</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="flex gap-6 text-sm">
          <div>
            <span className="text-muted-foreground">Tick:</span>{' '}
            <span className="font-medium">{world.current_tick}</span>
          </div>
          {nationCount !== undefined && (
            <div>
              <span className="text-muted-foreground">Nations:</span>{' '}
              <span className="font-medium">{nationCount}</span>
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  )
}
